import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./styles.css";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../context/userContext";
import { Spinner } from "react-bootstrap";

const HomeSlider = ({ games, enabledGames }) => {
  const { userLoggedIn, setShowLogin } = useUserContext();
  const navigate = useNavigate();

  const GameTiles = [
    { title: "Alphabets", img: "/Images/Alphabet.png", status: "New" },
    { title: "Numbers", img: "/Images/Numbers.png", status: "New" },
    { title: "Colours", img: "/Images/Color.png", status: "New" },
    { title: "Family", img: "/Images/Family.png", status: "New" },
    { title: "Greeting", img: "/Images/Greeting.png", status: "New" },
    { title: "Painting", img: "/Images/painting.png", status: "New" },
  ];

  const gameStatusCheck = (title) => {
    return games.includes(title) ? "Completed" : "New";
  };

  const visibleGames = GameTiles.filter((game) =>
    enabledGames.some((g) => g.name === game.title && g.enabled === true),
  );

  const slideCount = visibleGames.length;

  const settings = {
    dots: false,
    infinite: slideCount > 3,
    arrows: slideCount > 3,
    speed: 500,
    slidesToShow: Math.min(3, slideCount),
    slidesToScroll: Math.min(3, slideCount),
    autoplay: slideCount > 3,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(3, slideCount),
          slidesToScroll: Math.min(3, slideCount),
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: Math.min(2, slideCount),
          slidesToScroll: Math.min(2, slideCount),
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleNavigate = (tile) => {
    if (!userLoggedIn) {
      setShowLogin(true);
      return;
    }

    const status = gameStatusCheck(tile.title);
    const queryString = new URLSearchParams({
      game: tile.title,
      status,
    }).toString();

    navigate(`/category?${queryString}`);
  };

  return (
    <div className="slider-container col-6 home-slider">
      <Slider {...settings}>
        {visibleGames.map((tile, index) => (
          <div
            key={index}
            className="cat-card"
            onClick={() => handleNavigate(tile)}
          >
            {userLoggedIn &&
              (gameStatusCheck(tile.title) === "New" ? (
                <div className="game-status new-game">New</div>
              ) : (
                <div className="game-status completed-game">completed</div>
              ))}

            <img src={tile.img} alt="" />
            <p>{tile.title}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HomeSlider;
